import { BannerAlert } from "~/components/banner_alert";

interface PaymentReviewBannerProps {
  isDepositInReview?: boolean;
  isRemainderInReview?: boolean;
  isPaymentInReview?: boolean;
}

export function PaymentReviewBanner({
  isDepositInReview,
  isPaymentInReview,
  isRemainderInReview,
}: PaymentReviewBannerProps) {
  if (!isDepositInReview && !isRemainderInReview && !isPaymentInReview) {
    return null;
  }

  return (
    <BannerAlert
      title="Under Review"
      message="This payment is currently undergoing a manual security review. Do not fulfill the order until it has been approved. If rejected, the payment will be reverted and fully refunded."
    />
  );
}
